module.exports = __webpack_public_path__ + "static/media/RRC-JackjonPT-website-mockup-iphone-w768.682b7bfa.webp";